var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPutOnHold = function SvgPutOnHold(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM7.14286 6.42857C6.95342 6.42857 6.77174 6.50383 6.63778 6.63778C6.50383 6.77174 6.42857 6.95342 6.42857 7.14286V12.8571C6.42857 13.0466 6.50383 13.2283 6.63778 13.3622C6.77174 13.4962 6.95342 13.5714 7.14286 13.5714H12.8571C13.0466 13.5714 13.2283 13.4962 13.3622 13.3622C13.4962 13.2283 13.5714 13.0466 13.5714 12.8571V7.14286C13.5714 6.95342 13.4962 6.77174 13.3622 6.63778C13.2283 6.50383 13.0466 6.42857 12.8571 6.42857H7.14286Z",
    fill: "#C83333"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPutOnHold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "putOnHold.27215bda9137fc97bdb596025e894d9d.svg";